import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const VerifyButton = ({ onClick, loading, label = 'Verify Emails' }) => {
  return (
    <Button
      variant="contained"
      color="primary"
      onClick={onClick}
      disabled={loading}
      startIcon={!loading && <CheckCircleIcon />}
      sx={{ minWidth: 160, fontWeight: 'bold' }}
    >
      {loading ? <CircularProgress size={24} color="inherit" /> : label}
    </Button>
  );
};

export default VerifyButton;
